module.exports = __webpack_public_path__ + "img/Vector 384 (4).5bab54d9.png";